module.exports = __webpack_public_path__ + "img/iconfinder-icon-image.922fed79.jpg";